// extracted by mini-css-extract-plugin
export default {"leftPanel":"LeftPanel_leftPanel__jO37N","twitterIcon":"LeftPanel_twitterIcon__gxput"};